const isIntegerMatch = (a: number | string, b: number | string) => {
  const x = typeof a === 'string' ? parseInt(a, 10) : a;
  const y = typeof b === 'string' ? parseInt(b, 10) : b;
  return x === y;
};

export default isIntegerMatch;
